export default {
      id: "top_post-usage",
      viewBox: "0 0 2100 75",
      url: "../../../plugins/creasit-builder/assets/dist/images/" + "sprite.svg#top_post-usage",
      toString: function () {
        return this.url;
      }
    }